import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clockOut, startCleanMode, updateElapsedTime, startBreak, endBreak, updatePrevSeconds, UPDATE_START_TIME, updateStartTime } from '../../../store/actions/PrepActions';
import moment from 'moment-timezone';
import nbrApi from '../../../services/nbrApi';
import { toast } from 'react-toastify';
import { dateToUnix, formatDate, formatElapsedTime, formatElapsedTimenew, formatTime, formatTimeStr, formatTimeTillMin, getFloorName, isRoomCleaning, parseCartLocationResponse, parseTimeToSeconds, timeRemoveSecs } from '../../../services/common.utils';
import { BeatLoader } from 'react-spinners';
import Swal from 'sweetalert2';
import ShiftTable from './ShiftTable';
import { useLogout } from '../../../context/UseLogout';
import ShiftCountdown from './ShiftConutdown';
import CountdownTimer from './CountdownTimer';
import { setCookie } from '../../../services/session.utils';
import { useNavigate } from 'react-router-dom';
import cartIcon from '../../../images/guestInit.png'
import CartLocationManager from './CartLocationManager';
const PrepModeComponent = () => {
    const isDev = false
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { logoutUser } = useLogout();

    const { inPrepMode, tmName, date, elapsedTime, inCleanMode, startTime, previous_seconds, onBreak } = useSelector(state => state.prepReducer);
    const selectedLoginData = JSON.parse(localStorage.getItem('selectedLoginData')) || {}
    // console.log(selectedLoginData)
    const userData = JSON.parse(localStorage?.getItem('userDetails')) || {}
    const [isClockLoading, setClockLoading] = useState(false);
    const [ss_is_in, setSsIn] = useState('')
    const [ss_is_out, setSsOut] = useState('')
    const [segmant_name, setSegmantName] = useState('')
    const [current_segment, setCurrentSegment] = useState('Clock In')
    const [tcs_id_out, setTcsOut] = useState(null);
    const [propertiesID, setPropertiesID] = useState(null)
    const [apiPreviousSeconds, setApiPreviousSeconds] = useState(0);
    const startTimeRef = useRef(null);
    const [isPink, setIsPink] = useState(false)
    const [time_active, setTimeActive] = useState('')
    const [cartLocation, setCartLocation] = useState("");
    const [floors, setFloors] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [selectedFloor, setSelectedFloor] = useState("");
    const [selectedRoom, setSelectedRoom] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [canShowCleaningBtn, setCanShowCleaningBtn] = useState(false)

    useEffect(() => {
        let callApi = false
        if (callApi) {
            let payload = {
                "resources_id": 13,
                "roles_id": 15,
                "test_delay": 120,
                "segment_seconds_1": 650,
                "segment_seconds_2": 800
            }
            const res = nbrApi.post('/setdynamicelementstestdata', payload)
            console.log(res.data)

        }
    }, [])

    useEffect(() => {
        if (propertiesID === null) {
            setPropertiesID(selectedLoginData?.properties_id)
        }
    }, [selectedLoginData])


    const userDetailsAll = JSON.parse(localStorage?.getItem('userDetailsAll')) || {}
    const ss_id_active = userDetailsAll?.session_info?.ss_id_active || null
    const [dynamicData, setDynamicData] = useState({})

    // let dynamicData = userDetailsAll?.dynamic_elements || {}
    let selectedDataFilter = userData?.filter(e =>
        e?.properties_id === parseInt(selectedLoginData?.properties_id) &&
        e?.roles_id === Number(selectedLoginData?.role_id)
    )?.[0]
    let selectedData = userDetailsAll?.user_info ? userDetailsAll?.user_info : selectedDataFilter
    let hkscheduledetails = userDetailsAll?.schedule_info || {}
    const [data, setData] = useState([])
    let shift_data = userDetailsAll?.schedule_info?.shift_array || []
    // console.log(hkscheduledetails)
    const normalizeScheduleYmd = (v) => (v == null || v === '' ? '' : String(v).trim().slice(0, 10));
    // Hotel/property calendar date from API — use for schedule UI and clock-in date checks (not browser local date).
    const scheduleCurrentDateYmd = normalizeScheduleYmd(hkscheduledetails?.current_date_local);
    const currentDateForSchedule = scheduleCurrentDateYmd || normalizeScheduleYmd(moment().format('YYYY-MM-DD'));
    // Extract detail date, shift start, and shift end from data // '2024-09-09' //
    const detailDate = hkscheduledetails?.schedule_details?.detail_date_today //moment(hkscheduledetails?.schedule_details?.detail_date_today).format('YYYY-MM-DD');
    const detailDateYmd = normalizeScheduleYmd(detailDate);
    const detailDateNext = hkscheduledetails?.schedule_details?.detail_date_next //moment(hkscheduledetails?.schedule_details?.detail_date_next).format('YYYY-MM-DD');
    const shiftStart = hkscheduledetails?.schedule_details?.shift_start_today //?.split(' ')?.[1]
    const shiftEnd = hkscheduledetails?.schedule_details?.shift_end_today //?.split(' ')?.[1] 
    let login_elapsed_time = hkscheduledetails?.schedule_details?.previous_seconds || 0
    let segment_list = hkscheduledetails?.shift_array?.map(e => e?.segment_name?.replaceAll(' ', '_'))
    let hksID = userDetailsAll?.schedule_info?.schedule_details?.hksd_id

    // check if can show cleaning btn
    useEffect(() => {
        let canShowCleaningBtn = localStorage.getItem('canShowCleaningBtn')
        const currentSegment = userDetailsAll?.schedule_info?.schedule_details?.current_segment_name
        // console.log('currentSegment', currentSegment, currentSegment?.toLowerCase().includes('cleaning'))

        // If current segment doesn't include 'cleaning', remove from localStorage and set to false
        if (currentSegment && currentSegment?.toLowerCase().includes('cleaning')) {
            setCanShowCleaningBtn(true)
        } else if (canShowCleaningBtn === 'true') {
            setCanShowCleaningBtn(true)
        } else {
            localStorage.removeItem('canShowCleaningBtn')
            setCanShowCleaningBtn(false)
        }
    }, [userDetailsAll])

    // reset data
    const resetShiftSegment = async () => {
        // console.log(userDetailsAll?.schedule_info?.shift_array?.length, !userDetailsAll?.schedule_info?.schedule_details?.next_ss_id,
        //     userDetailsAll?.schedule_info?.shift_array?.length === 0 || !userDetailsAll?.schedule_info?.schedule_details?.next_ss_id && isDev === true)
        // if ((userDetailsAll?.schedule_info?.shift_array?.length === 0 || !userDetailsAll?.schedule_info?.schedule_details?.next_ss_id) && isDev === true) {
        if (selectedData?.resources_id && isDev) {
            let api = '/resetuserdata'
            let payload = {
                // hksd_id: hksID
                resources_id: selectedData?.resources_id,
                date_val: moment(new Date()).format('YYYY-MM-DD') //2025-01-04"
            }

            const resp = await nbrApi.post(api, payload)
            if (resp?.data) {
                logoutUser(selectedData);
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: `Reset Shift Segment Data`,
                    text: 'Please Login Again !',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            console.log('hks_id not available')
        }
        // }
    }

    useEffect(() => {
        if (isDev === true) {
            // console.log(true)
            resetShiftSegment()
        }
    }, [])

    useEffect(() => {
        if (userDetailsAll?.dynamic_elements && !dynamicData) {
            // console.log('shifting')
            setDynamicData(userDetailsAll?.dynamic_elements)
        }
    }, [userDetailsAll])

    useEffect(() => {
        let segment = current_segment?.toLowerCase() === 'clock in' ? segment_list[0] : current_segment?.toLowerCase()
        let isPaidData = hkscheduledetails?.shift_array?.find(e => e?.segment_name === segment)
        if (isPaidData?.paid_time === 1) {
            setIsPink(true)
        } else {
            setIsPink(false)
        }
        // console.log(segment,isPaidData, isPink)
    }, [current_segment])

    // console.log(shiftStart, shiftEnd)
    useEffect(() => {
        setData(shift_data)
    }, [])

    const getDynamicsList = async () => {
        let path = '/getdynamicelements'
        let payload = {
            "properties_id": selectedLoginData?.properties_id,
            "resources_id": selectedData?.resources_id,
            "hksd_id": hksID,
            "roles_id": selectedLoginData?.role_id
        }
        const res = await nbrApi.post(path, payload)
        let data = JSON.parse(localStorage?.getItem('userDetailsAll'))
        let modified_data = {
            ...data,
            dynamic_elements: res?.data?.dynamic_elements
        }
        setDynamicData(res?.data?.dynamic_elements)
        localStorage.setItem('userDetailsAll', JSON.stringify(modified_data))
    }

    useEffect(() => {
        // Function to get dynamics list
        const fetchDynamicsList = () => {
            // if (userDetailsAll) {
            getDynamicsList();
            // }
        };

        // Call fetchDynamicsList immediately
        fetchDynamicsList();

        // Set up an interval to call fetchDynamicsList every 10 seconds
        const intervalId = setInterval(fetchDynamicsList, 15000);

        // Cleanup function to clear the interval when the component unmounts
        return () => {
            clearInterval(intervalId);
        };
    }, []);


    useEffect(() => {
        let interval;

        // Check if inCleanMode and time_in_active is available
        const timeInActive = userDetailsAll?.session_info?.time_in_active;

        if (timeInActive) {
            // Convert time_in_active (YYYY-MM-DD HH:mm:ss) to a Date object
            const activeDate = new Date(timeInActive); // Replace dashes with space

            // Set the current startTime as a reference point
            startTimeRef.current = activeDate.getTime(); // Get time in milliseconds

            interval = setInterval(() => {
                const currentTime = Date.now();

                // Calculate elapsed time in milliseconds
                const elapsedMs = currentTime - startTimeRef.current;

                // Format the elapsed time as hh:mm:ss
                const formattedTime = formatElapsedTime(new Date(elapsedMs)) //formatElapsedTimenew(elapsedMs);
                console.log(currentTime, timeInActive?.replace(/-/g, ' '))
                // Store in localStorage and dispatch the formatted time
                localStorage.setItem('elapsedTime', formattedTime);
                // console.log(formattedTime, '289')
                dispatch(updateElapsedTime(formattedTime));
            }, 1000); // Run every second
        } else if (inCleanMode && startTime) {
            startTimeRef.current = Date.now();

            interval = setInterval(() => {
                const currentTime = Date.now();
                // const elapsedMs = currentTime - startTimeRef.current + apiPreviousSeconds * 1000;
                const elapsedMs = currentTime - startTimeRef.current;  // Start from 0 every time

                const formattedTime = formatElapsedTime(new Date(elapsedMs));
                // console.log(formattedTime)

                localStorage.setItem('elapsedTime', formattedTime)
                // console.log(formattedTime, '304', elapsedMs)
                dispatch(updateElapsedTime(formattedTime));
            }, 1000);
        }

        return () => clearInterval(interval);  // Cleanup the interval on component unmount
    }, [inCleanMode, userDetailsAll, startTime, dispatch]);

    useEffect(() => {
        if (!ss_is_out) {
            setSsOut(hkscheduledetails?.schedule_details?.ss_is_out ? hkscheduledetails?.schedule_details?.ss_is_out : 0)
        }

        if (!ss_is_in) {
            setSsIn(hkscheduledetails?.schedule_details?.next_ss_id ? hkscheduledetails?.schedule_details?.next_ss_id : null)
        }

        if (!tcs_id_out) {
            setTcsOut(hkscheduledetails?.schedule_details?.tcs_id_active ? hkscheduledetails?.schedule_details?.tcs_id_active : 0)
        }

        // if (!tcs_id_in) {
        //     setTcsOut(hkscheduledetails?.schedule_details?.tcs_id_in ? hkscheduledetails?.schedule_details?.tcs_id_in : 0)
        // }

        if (!segmant_name) {
            setSegmantName(hkscheduledetails?.schedule_details?.next_shift_segment_name ? hkscheduledetails?.schedule_details?.next_shift_segment_name : segment_list[0])
        }

        if (!time_active) {
            let active_time = userDetailsAll?.session_info?.time_in_active;
            if (active_time) {
                let activeDate = new Date(active_time.replace(/-/g, '/')); // Replace dashes for compatibility with Date parsing
                let currentDate = new Date();
                let timeDiff = currentDate - activeDate;

                // Convert the difference into hours, minutes, and seconds
                let hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
                let minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
                let seconds = Math.floor((timeDiff / 1000) % 60);

                // Format the time as hh:mm:ss
                let elapsedTime =
                    String(hours).padStart(2, '0') + ':' +
                    String(minutes).padStart(2, '0') + ':' +
                    String(seconds).padStart(2, '0');

                setTimeActive(elapsedTime);
                // console.log(elapsedTime, '352')
                dispatch(updateElapsedTime(elapsedTime));
            } else {
                setTimeActive('');
            }
        }

        // if (!current_segment) {
        setCurrentSegment(hkscheduledetails?.schedule_details?.current_segment_name ? hkscheduledetails?.schedule_details?.current_segment_name : 'Clock In')
        // }

    }, [])

    // Helper function to update schedule details
    function updateScheduleDetails(details) {
        return {
            ...userDetailsAll,
            schedule_info: {
                ...userDetailsAll?.schedule_info,
                schedule_details: {
                    ...userDetailsAll?.schedule_info?.schedule_details,
                    ...details
                }
            }
        };
    }

    const handleClock = async (params) => {
        setTimeActive('')
        // Check if the detail date is equal to the current date
        if (detailDateYmd === currentDateForSchedule) {
            // Check if the current time is between shift start and shift end
            // if ((currentTime >= shiftStart && currentTime <= shiftEnd)) {
            let api = params === 'in' ? '/clockin' : '/clockout';
            let payload = {};
            setClockLoading(true);

            if (params === 'in') {
                payload = {
                    "resources_id": selectedData?.resources_id,
                    "properties_id": selectedLoginData?.properties_id,
                    "roles_id": userDetailsAll?.session_info?.roles_id,
                    "current_function": "clean",
                    "hkschedules_id": hkscheduledetails?.schedule_details?.hkschedules_id, //selectedData?.sl_id ? selectedData?.sl_id : null,
                    "hkscheduledetails_id": hkscheduledetails?.schedule_details?.hksd_id,
                    "ss_id_out": ss_is_out,
                    "ss_id_in": ss_is_in,
                    "tcs_id_out": tcs_id_out,
                    "mrr_id" : userDetailsAll?.session_info?.mrr_id
                };
            } else {
                payload = {
                    "resources_id": selectedData?.resources_id,
                    "properties_id": selectedLoginData?.properties_id,
                    "ss_id_out": ss_is_out,
                    "tcs_id_out": tcs_id_out,
                    "tcs_id_in": 0,
                    "hksd_id": hksID,
                    "schedule_info": {},
                    "mrr_id" : userDetailsAll?.session_info?.mrr_id
                };
            }
            // console.log(payload)
            if (params === 'in') {
                try {
                    const resp = await nbrApi.post(api, payload);
                    // let resp = {}
                    // if(response?.data){
                    //     resp = {data: response?.data}
                    // }else{
                    //     resp = {data: response}
                    // }
                    // console.log(params, resp?.data, resp?.data?.schedule_info)
                    if (resp?.data) {
                        setClockLoading(false);

                        if (params === 'in') {
                            let nextSSID = ''
                            let segmantName = ''
                            let tcsOut = ''
                            const activeType = resp?.data?.schedule_info?.schedule_details?.shift_segment_type_name_active;
                            // console.log(activeType, 'activeType')
                            const isCleaning = typeof activeType === 'string' && (activeType.toLowerCase().includes('cleaning') || activeType.toLowerCase().includes('supervisory'));
                            // console.log(isCleaning, 'isCleaning')

                            if (isCleaning) {
                                setCanShowCleaningBtn(true);
                                localStorage.setItem('canShowCleaningBtn', 'true');
                            } else {
                                setCanShowCleaningBtn(false);
                                localStorage.setItem('canShowCleaningBtn', 'false');
                            }
                            if (resp?.data?.next_ss_id) {
                                nextSSID = resp?.data?.next_ss_id
                                segmantName = resp?.data?.next_shift_segment_name
                                tcsOut = resp?.data?.tcs_id_active
                                // let tcsIn = resp?.data?.tcs_id_out
                                let modified_data = {
                                    ...userDetailsAll,
                                    schedule_info: {
                                        ...userDetailsAll?.schedule_info,
                                        schedule_details: {
                                            ...userDetailsAll?.schedule_info?.schedule_details,
                                            next_ss_id: nextSSID,
                                            next_shift_segment_name: segmantName,
                                            tcs_id_out: tcsOut,
                                            tcs_id_active: tcsOut,
                                            ss_is_out: ss_is_in,
                                            current_segment_name: segmant_name?.toLowerCase() === 'clock in' ? segment_list[0] : segmant_name
                                            // tcs_id_in: tcsIn
                                        }
                                    },
                                    session_info: {
                                        ...userDetailsAll?.session_info,
                                        ...resp?.data?.session_info,
                                        time_in_active: formatDate(new Date())
                                    }
                                }

                                setSsIn(nextSSID)
                                setSsOut(ss_is_in)
                                setSegmantName(segmantName)
                                setCurrentSegment(segmant_name)
                                // setTcsIn(tcsIn)
                                setTcsOut(tcsOut)
                                localStorage.setItem('userDetailsAll', JSON.stringify(modified_data))
                            }
                            if (resp?.data?.schedule_info) {
                                // console.log(resp?.data?.schedule_info?.shift_array, '(resp?.data?.schedule_info?.shift_array')
                                // Update the local state with the new shift_array data
                                if (resp?.data?.schedule_info?.shift_array) {
                                    setData(resp?.data?.schedule_info?.shift_array)
                                }
                                let data = {
                                    ...userDetailsAll,
                                    schedule_info: {
                                        ...resp?.data?.schedule_info,
                                        schedule_details: {
                                            ...resp?.data?.schedule_info?.schedule_details,
                                            next_ss_id: nextSSID,
                                            next_shift_segment_name: segmantName,
                                            tcs_id_out: tcsOut,
                                            tcs_id_active: tcsOut,
                                            current_segment_name: segmant_name
                                        }
                                    },
                                    session_info: {
                                        ...userDetailsAll?.session_info,
                                        ...resp?.data?.session_info,
                                        time_in_active: formatDate(new Date())
                                    }
                                }
                                localStorage.setItem('userDetailsAll', JSON.stringify(data))
                            }
                            if (!resp?.data?.next_ss_id || !resp?.data?.next_shift_segment_name) {
                                // alert('test 123')
                                // let nextSSID = null
                                nextSSID = resp?.data?.ss_id_in
                                tcsOut = resp?.data?.tcs_id_active

                                segmantName = 'Cart Wrap'
                                // let tcsOut = 0
                                // let tcsIn = 0
                                let modified_data = {
                                    ...userDetailsAll,
                                    schedule_info: {
                                        ...userDetailsAll?.schedule_info,
                                        schedule_details: {
                                            ...userDetailsAll?.schedule_info?.schedule_details,
                                            next_ss_id: nextSSID,
                                            next_shift_segment_name: segmantName,
                                            tcs_id_out: tcsOut,
                                            tcs_id_active: tcsOut,
                                            current_segment_name: segmant_name?.toLowerCase() === 'clock in' ? segment_list[segment_list?.length - 1] : segmant_name
                                            // tcs_id_in: tcsIn
                                        }
                                    },
                                    session_info: {
                                        ...userDetailsAll?.session_info,
                                        ...resp?.data?.session_info,
                                        time_in_active: formatDate(new Date())
                                    }
                                }

                                setSsIn(null)
                                setSsOut(nextSSID)
                                setSegmantName(segmantName)
                                setCurrentSegment(segmant_name)
                                setTcsOut(tcsOut)
                                localStorage.setItem('userDetailsAll', JSON.stringify(modified_data))
                            }
                            // if (resp?.data?.previous_seconds) {
                            //     dispatch(updatePrevSeconds(formatTimeStr(resp?.data?.previous_seconds)));
                            // }
                            if (resp?.data?.previous_seconds) {
                                const prevSeconds = 0 //parseTimeToSeconds(resp?.data?.previous_seconds);
                                setApiPreviousSeconds(0)//(prevSeconds);
                                dispatch(updateElapsedTime(formatElapsedTime(new Date(prevSeconds * 1000))));
                            }
                            if (resp?.data?.session_info?.segment_name_active) {

                                Swal.fire({
                                    position: 'center',
                                    icon: 'success',
                                    title: `${current_segment?.toLowerCase() !== 'clock in' ?
                                        `Entering ` + resp?.data?.session_info?.segment_name_active + ' mode' : 'Entering Prep Mode'}`, //`Entering ${resp?.data?.next_shift_segment_name} mode`,
                                    showConfirmButton: false,
                                    timer: 2000,
                                })

                                // Only force cleaning mode for room attendant role
                                if ((isRoomCleaning(resp?.data?.session_info?.segment_name_active)) && userDetailsAll?.session_info?.role_name === 'room attendant') {
                                    localStorage.setItem('next_shift', JSON.stringify(resp?.data));
                                    // setShowModal(true)
                                }

                            }

                            dispatch(startCleanMode());
                            // if (resp?.data?.tcs_id) {
                            //     setTcsID(resp?.data?.tcs_id);
                            // }
                        }

                    } else {
                        toast.error('Something went wrong', { theme: 'dark' });
                        setClockLoading(false);
                    }
                } catch {
                    toast.error('Something went wrong', { theme: 'dark' });
                    setClockLoading(false);
                }
            } else {
                // Show confirmation alert for clock out
                Swal.fire({
                    title: "You have completed today's shift",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Clock Out',
                    cancelButtonText: 'Stay Clocked In',
                    confirmButtonColor: '#ff4b4b', // Custom color for clock out
                    cancelButtonColor: '#3085d6',
                    reverseButtons: true,
                    customClass: {
                        confirmButton: 'circle-stop', // Optional custom class for button styling
                        cancelButton: 'circle-start'
                    }
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        payload = {
                            ...payload,
                            clockout_reason: 'end od shift'
                        }
                        const resp = await nbrApi.post(api, payload);

                        // If Clock Out is confirmed, call the clock out API
                        let nextSSID = null
                        let segmantName = null
                        let tcsOut = null

                        nextSSID = null
                        segmantName = segment_list[0]
                        tcsOut = 0
                        let modified_data_new = {
                            ...userDetailsAll,
                            schedule_info: {
                                ...userDetailsAll?.schedule_info,
                                schedule_details: {
                                    ...userDetailsAll?.schedule_info?.schedule_details,
                                    next_ss_id: nextSSID,
                                    next_shift_segment_name: segmantName,
                                    tcs_id_out: tcsOut,
                                    ss_is_out: ss_is_in,
                                    current_segment_name: segmant_name
                                }
                            },
                            session_info: {
                                ...userDetailsAll?.session_info,
                                time_in_active: null
                            }
                        }
                        setSsIn(null)
                        setSsOut(nextSSID)
                        setSegmantName(segmantName)
                        setCurrentSegment(segmantName)
                        setTcsOut(tcsOut)
                        localStorage.setItem('userDetailsAll', JSON.stringify(modified_data_new))

                        if (resp?.data?.previous_seconds) {
                            const prevSeconds = 0 //parseTimeToSeconds(resp?.data?.previous_seconds);
                            setApiPreviousSeconds(0)//(prevSeconds);
                            dispatch(updateElapsedTime(formatElapsedTime(new Date(prevSeconds * 1000))));
                        }
                        if (resp?.data?.schedule_info) {
                            setData(resp?.data?.schedule_info?.shift_array)
                            let data = {
                                ...userDetailsAll,
                                schedule_info: {
                                    ...resp?.data?.schedule_info,
                                    next_ss_id: nextSSID,
                                    next_shift_segment_name: segmantName,
                                    tcs_id_out: tcsOut,
                                    tcs_id_active: tcsOut,
                                    current_segment_name: segmant_name

                                },
                                session_info: {
                                    ...userDetailsAll?.session_info,
                                    time_in_active: null
                                }
                            }
                            localStorage.setItem('userDetailsAll', JSON.stringify(data))
                        }

                        dispatch(clockOut());
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Clocked out successfully!',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    } else {
                        // Just close the modal, no further action needed
                        Swal.close();
                    }
                });
            }


            // } else {
            //     Swal.fire({
            //         position: 'center',
            //         icon: 'info',
            //         title: 'Clock in is not available.',
            //         text: 'You are not scheduled to work at this time.',
            //         showConfirmButton: false,
            //         timer: 2000,
            //     });
            // }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'info',
                title: 'Clock in is not available.',
                text: 'You are not scheduled to work at this time.',
                showConfirmButton: false,
                timer: 2000,
            });
        }

    }

    const handleBreak = () => {
        if (onBreak) {
            dispatch(endBreak(elapsedTime));
        } else {
            dispatch(startBreak(elapsedTime));
        }
    };

    useEffect(() => {
        if (ss_is_in === null) {
            resetShiftSegment()
        }
    }, [ss_is_in])


    const renderTime = () => {
        if (dynamicData?.show_shift_context !== 'today') {
            // if (hkscheduledetails?.schedule_details?.shift_start_next) {
            return (
                <p className='text-secondary fs-4'>{formatTimeTillMin(hkscheduledetails?.schedule_details?.shift_start_next)} - {formatTimeTillMin(hkscheduledetails?.schedule_details?.shift_end_next)}</p>
            )
        } else {
            return (
                <p className='text-secondary fs-4'>{formatTimeTillMin(hkscheduledetails?.schedule_details?.shift_start_today)} - {formatTimeTillMin(hkscheduledetails?.schedule_details?.shift_end_today)}</p>
            )
        }
    }

    const renderTimeText = () => {
        if (dynamicData?.show_shift_context !== 'today') {
            // if (hkscheduledetails?.schedule_details?.shift_start_next && hkscheduledetails?.schedule_details?.shift_start_next !== '00:00:00') {
            return 'Next Schedule'
        } else {
            return 'Today\'s Schedule'
        }
    }

    // Fetch current cart location
    useEffect(() => {
        if (selectedLoginData?.properties_id && selectedData?.resources_id) {
            nbrApi.post('/getcartlocation', {
                    properties_id: selectedLoginData?.properties_id,
                    resources_id: selectedData?.resources_id,
                })
                .then((res) => res.data)
                .then((data) => {
                    const cartData = parseCartLocationResponse(data);
                    if (cartData?.floor != null && cartData?.room_number != null) {
                        setCartLocation(getFloorName(cartData.floor) + ' (' + cartData.room_number + ')');
                        setSelectedFloor(cartData.floor);
                        setSelectedRoom(cartData.room_number);
                    }
                })
                .catch((error) => console.error("Error fetching cart location:", error));
        }
    }, [selectedLoginData?.properties_id, selectedData?.resources_id]);

    const handleInspectionMode = () => {
        // console.log('handleInspectionMode')
        setShowModal(true)
    }

    let nextShift = JSON.parse(localStorage.getItem("next_shift"));

    console.log('canShowCleaningBtn', canShowCleaningBtn)
    return (
        <div className='card p-4 m-auto py-lg-5 prepCT'>
            {/* Cart Popup */}
            {cartLocation &&
                <CartLocationManager
                    show={showModal}
                    setShow={setShowModal}
                    cartLoc={cartLocation}
                    setCartLoc={setCartLocation}
                    floor={selectedFloor}
                    setFloor={selectedFloor}
                    room={selectedRoom}
                    setRoom={setSelectedRoom}
                    selectedLoginData={selectedLoginData}
                    selectedData={selectedData}
                    cartIcon={cartIcon}
                    ss_in={ss_id_active}
                    roleName={userDetailsAll?.session_info?.role_name}
                    status="active"
                />}
            <div className='card-content'>
                {/* <h1 className='text-center text-capitalize'
                    style={{
                        color: '#e91e63'
                    }}
                >
                    Prep Mode
                </h1> */}

                <div className='mt-lg-5 text-center'>
                    <h2 className='text-uppercase'>Welcome, {`${selectedData?.resource_first ?? ''} ${selectedData?.resource_last ?? ''}`.trim()}</h2>
                    <h3 className='fw-normal'>{
                        scheduleCurrentDateYmd
                            ? moment(scheduleCurrentDateYmd, 'YYYY-MM-DD').format('MMM Do, YYYY')
                            : moment().format('MMM Do, YYYY')
                    }</h3>
                </div>

                {/* if date not matched */}
                {hkscheduledetails?.schedule_details && (detailDateYmd !== currentDateForSchedule ?
                    <p className='text-center fs-3 text-black fw-medium mt-lg-5'>
                        You are not scheduled to work at <b>{selectedData?.property_name}</b> today
                    </p>
                    :
                    <div className='container text-center mt-0 mt-lg-5'>
                        <h4 className='text-primary'>{renderTimeText()}</h4>
                        {renderTime()}
                    </div>
                )}

                {/* Missed Today's Shift */}
                {/* {dynamicData?.show_missed_shift_message &&
                    <p className='text-center fs-3 text-black fw-medium mt-lg-5 text-capitalize'>
                        You missed today's shift. Please contact your supervisor ASAP
                    </p>
                } */}


                {
                    // parseTimeToSeconds(elapsedTime) > 0 &&
                    (detailDateYmd === currentDateForSchedule
                        // && (currentTime >= shiftStart && currentTime <= shiftEnd) 
                        && <div className={`d-flex justify-content-center ${inCleanMode ? 'gap-lg-3' : 'gap-lg-5 mt-lg-5'} flex-column`}>


                            {/* {inCleanMode && */}
                            {dynamicData?.show_shift_details &&
                                <div className='d-flex justify-content-center mt-3'>
                                    {/* Shift table & Graph */}
                                    <ShiftTable
                                        segment_list={segment_list}
                                        isPink={isPink}
                                        ss_is_in={ss_is_in}
                                        setData={setData}
                                        data={data}
                                        currentSegment={current_segment ?
                                            current_segment : segment_list[0]}

                                        elapsedTime={elapsedTime}
                                    />
                                </div>}


                            {/* Show Elapsed Time */}
                            {/* <div className='text-center'>
                                <h4 className='text-primary'>{(elapsedTime)}</h4>
                                <medium className='text-secondary text-capitalize'> <b>active segment time</b></medium>
                            </div> */}
                        </div>)}

                {/* Next shift start date */}
                {/* {dynamicData?.show_next_shift_start_date &&
                    <p className='text-center fs-3 text-black fw-medium mt-lg-5'>
                        It's much too early to clock in
                    </p>
                } */}
                {dynamicData?.show_next_shift_start_date && dynamicData?.shift_start_next && (
                    <CountdownTimer
                        targetTime={dynamicData?.shift_start_next}
                        message="Next shift will be start in"
                    />
                )}
                {/* Clockin Countdown Clock */}
                {/* {dynamicData?.show_clockin_countdown_clock &&
                    <p className='text-center fs-3 text-black fw-medium mt-lg-5 text-capitalize'>
                        It's getting close to clocking in
                    </p>
                } */}

                {dynamicData?.show_clockin_countdown_clock && (
                    <CountdownTimer
                        targetTime={dynamicData?.early_clockin_start_time}
                        message="Time remaining before early clock-in"
                    />
                )}


                {/* show_clockin_button  */}
                {/* {dynamicData?.show_clockin_button &&
                    <p className='text-center fs-3 text-black fw-medium mt-lg-5 text-capitalize'>
                        It's within the time that I can clock in a little early
                    </p>
                } */}
                {dynamicData?.show_clockin_button &&
                    (!dynamicData?.show_next_shift_start_date && !dynamicData?.show_late_clockin_message) &&
                    <p className='text-center fs-3 text-black fw-medium mt-lg-5 text-capitalize'>
                        My shift has started and I can clock in now
                    </p>
                }
                {/* late start banner */}
                {dynamicData?.show_late_clockin_message &&
                    <p className='text-center fs-3 text-black fw-medium mt-lg-5 text-capitalize'>
                        you are late for your shift
                    </p>
                }
                {dynamicData?.show_shift_ending_countdown_clock && (
                    <CountdownTimer
                        targetTime={dynamicData?.shift_end_today}
                        message="Time remaining until shift ends"
                    />
                )}

                {dynamicData?.show_auto_clockout_message && (
                    <CountdownTimer
                        targetTime={dynamicData?.auto_clockout_time}
                        message="You will be clocked out in"
                    />
                )}
                {/* show_shift_ending_countdown_clock */}
                {/* {!dynamicData?.show_shift_ending_countdown_clock &&
                    <ShiftCountdown dynamicData={dynamicData} />
                } */}
                {/* late start banner */}
                {/* {dynamicData?.show_shift_segment_end_button &&
                    <p className='text-center fs-3 text-black fw-medium mt-lg-5 text-capitalize'>
                         My shift is over and I am still clocked in
                    </p>
                } */}
                {/* Shift ending Countdown Clock */}
                {dynamicData?.show_missed_shift_message &&
                    <p className='text-center fs-3 text-black fw-medium mt-lg-5 text-capitalize'>
                        I completely missed my shift
                    </p>
                }


            </div>

            {/* if date matched */}
            {/* {(detailDate === currentDate) && ((currentTime >= shiftStart && currentTime <= shiftEnd) && ss_is_in !== null ?
                <div className='mt-5 d-flex flex-column align-items-center gap-3'>
                    {(!isClockLoading) && (!inCleanMode ?
                        <>
                            <div className="circle-start" style={{ background: current_segment?.toLowerCase() === 'clock in' && '#E0346E' }}>
                                <p type='button' onClick={() => handleClock('in')} className="circle-content">
                                    <span className='text-capitalize'>{current_segment?.toLowerCase() !== 'clock in' ?
                                        `End ` + current_segment + ' mode' : 'Clock In'}</span>
                                </p>
                            </div>
                        </>
                        :
                        <>
                            <div className='d-flex gap-3'>
                                {!onBreak &&
                                    <div className="circle-start">
                                        <p type='button' onClick={() => handleClock('in')} className="circle-content">
                                            <span className='text-capitalize'>{current_segment?.toLowerCase() !== 'clock in' ? `End ` + current_segment + ' mode' : 'Clock In'}</span>
                                        </p>
                                    </div>
                                }

                               
                            </div>
                        </>
                    )}

                    {isClockLoading &&
                        <div className="circle-start">
                            <p type='button' onClick={() => setClockLoading(false)} className="circle-content">
                                <span className='fs-3'>Pending</span>
                                <BeatLoader
                                    color="white"
                                    margin={2}
                                    size={10} />
                            </p>
                        </div>}

                </div> :
                ss_is_in === null ?
                    current_segment?.toLowerCase() === segment_list[segment_list?.length - 1] ?
                        <div className='d-flex flex-column align-items-center mt-5'>
                            <div className="circle-start">
                                <p type='button' onClick={() => handleClock('out')} className="circle-content">
                                    <span className='text-capitalize'>{current_segment?.toLowerCase() == segment_list[segment_list?.length - 1] ? 'Clock out for the day' : current_segment?.toLowerCase() !== 'clock in' ? `End ` + current_segment + ' mode' : 'Clock In'}</span>
                                </p>
                            </div>
                        </div>
                        : <p className='text-center fs-3 text-black fw-medium mt-5 text-capitalize d-none'>
                            you have successfully clocked out
                        </p>
                    : <p className='text-center fs-3 text-black fw-medium mt-5'>
                       You are not scheduled to work in current shift 
                    </p>)} */}


            {((dynamicData?.show_clockin_button || dynamicData?.show_shift_segment_end_button) && ss_is_in !== null) ?
                <div className='mt-5 d-flex flex-column align-items-center gap-3'>
                    {!isClockLoading && <div className="circle-start" style={{ background: current_segment?.toLowerCase() === 'clock in' && '#E0346E' }}>
                        <p type='button' onClick={() => handleClock('in')} className="circle-content">
                            <span className='text-capitalize'>{current_segment?.toLowerCase() !== 'clock in' ?
                                `End ` + current_segment + ' mode' : 'Clock In'}</span>
                        </p>
                    </div>}
                    {isClockLoading &&
                        <div className="circle-start">
                            <p type='button' onClick={() => setClockLoading(false)} className="circle-content">
                                <span className='fs-3'>Pending</span>
                                <BeatLoader
                                    color="white"
                                    margin={2}
                                    size={10} />
                            </p>
                        </div>}
                </div> :
                ss_is_in === null ?
                    (current_segment?.toLowerCase() === segment_list[segment_list?.length - 1] || current_segment?.replace('_', ' ')?.toLowerCase() === segment_list[segment_list?.length - 1]?.replace('_', ' ')?.toLowerCase()) ?
                        <div className='d-flex flex-column align-items-center mt-5'>
                            <div className="circle-start">
                                <p type='button' onClick={() => handleClock('out')} className="circle-content">
                                    <span className='text-capitalize'>{current_segment?.toLowerCase() !== 'clock in' ? `End ` + current_segment + ' mode' : 'Clock In'}</span>
                                </p>
                            </div>
                        </div>
                        : <p className='text-center fs-3 text-black fw-medium mt-5 text-capitalize d-none'>
                            you have successfully clocked out
                        </p>
                    : <p className='text-center fs-3 text-black fw-medium mt-5'>
                        {/* You are not scheduled to work in current shift */}
                        {/* {ss_is_in?.toString()} */}
                    </p>}

            {/* Inspection Mode */}
            {canShowCleaningBtn && userDetailsAll?.session_info?.role_name !== 'room attendant' && <div className='d-flex justify-content-center mt-3'>
                <button className='btn btn-danger mt-5' onClick={() => handleInspectionMode()}>
                    Enter Inspection Mode
                </button>
            </div>}
            {canShowCleaningBtn && userDetailsAll?.session_info?.role_name === 'room attendant' && <div className='d-flex justify-content-center mt-3'>
                <button className='btn btn-danger mt-5' onClick={() => handleInspectionMode()}>
                    Enter Cleaning Mode
                </button>
            </div>}

        </div>
    );
};

export default PrepModeComponent;
